import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const BrandCardSideContent: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'w-screen h-screen bg-bg-light px-4 py-6',
        'md:bg-white md:w-auto md:h-auto md:p-0 md:flex md:flex-row md:rounded-3xl md:shadow-lg md:overflow-hidden',
        className
      )}
    >
      
      <div className="hidden md:block">
        <img
          src="/desktop-bg.jpg"
          alt=""
          className="w-[524px] h-[624px] object-cover"
        />
      </div>

      <div className="md:hidden">
        <AppLogo.LogoOnly className="w-[75px] max-w-full" />
      </div>

      <div className="flex flex-col items-center mt-[57px] md:mt-0 md:justify-center md:px-12 md:py-10 md:w-[480px] md:max-h-[624px] md:overflow-y-auto md:bg-[#F0F4FF]">
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
